import { useQueryClient } from '@tanstack/react-query';

import { type AvatarData, useEditQuizUser } from '@/api';
import {
  normalizeQuizAvatarData,
  syncMyProfileQueryCache,
} from '@/shared/utils';

import { type AvatarSaveStrategy } from './types';

/** /profile/edit 저장 전략: 프로필 DB 저장 후 변경 필드만 캐시에 반영한다. */
export function useProfileAvatarSave(): AvatarSaveStrategy {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useEditQuizUser();

  const save = async (avatar: AvatarData, name?: string) => {
    const normalizedAvatar = normalizeQuizAvatarData(avatar);

    await mutateAsync({
      data: {
        avatarData: normalizedAvatar,
        ...(name !== undefined && { name }),
      },
    });

    syncMyProfileQueryCache(queryClient, {
      avatarData: normalizedAvatar,
      ...(name !== undefined && { username: name }),
    });
  };

  return { save, isSaving: isPending };
}
